import { Component, OnInit, viewChild, ViewContainerRef } from '@angular/core';
import { Modal } from '../../modal';
import { showHide } from '../../modal-animations';

@Component({
    selector: 'app-modal-template-clean',
    templateUrl: './modal-template-clean.component.html',
    styleUrls: ['./modal-template-clean.component.scss'],
    animations: [showHide],
    standalone: false
})
export class ModalTemplateCleanComponent extends Modal implements OnInit {

  readonly contentRef = viewChild('content', { read: ViewContainerRef });

  get classes() {
    return this.options?.data?.classes;
  }

  constructor() {
    super();
  }

  ngOnInit() {

  }

}
